/**
 * TeamSystem Impact - Microsoft MSAL Configuration
 * Configurazione autenticazione Microsoft Azure AD
 */

import { Configuration, PopupRequest } from '@azure/msal-browser';
import { logger } from '@/config/logger';

const azureClientId = import.meta.env.VITE_AZURE_CLIENT_ID || '';
const azureTenantId = import.meta.env.VITE_AZURE_TENANT_ID || '';

if (!azureClientId || !azureTenantId) {
  logger.debug('Azure AD non configurato, mock auth attivo');
}

export const msalConfig: Configuration = {
  auth: {
    clientId: azureClientId,
    authority: `https://login.microsoftonline.com/${azureTenantId}`,
    redirectUri: window.location.origin + '/blank.html',
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage', // o 'localStorage'
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 0: // Error
            logger.error(message);
            return;
          case 1: // Warning
            logger.warn(message);
            return;
          case 2: // Info
            logger.info(message);
            return;
          case 3: // Verbose
            logger.debug(message);
            return;
        }
      },
    },
  },
};

// Scopes richiesti per Microsoft Graph
export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

// Silent request per acquisire token
export const tokenRequest = {
  scopes: ['User.Read'],
};
